import React, { useEffect, useState } from "react";
import { Card, Field, makeStyles, ProgressBar, Skeleton, SkeletonItem, tokens } from "@fluentui/react-components";
import useSubscriptionDetails, { SubscriptionResponse } from "../../services/subscription/useSubscripitonDetails";
import { formatDate } from "../../utils/helpers/dateTime";

const useStyles = makeStyles({
  heading: {
    color: "#858585",
    fontWeight: tokens.fontWeightMedium,
  },
  subHeading: {
    color: "#858585",
    fontSize: "0.8rem",
  },
  planName: {
    color: "#4d4d4d",
    fontSize: "1rem",
    fontWeight: tokens.fontWeightSemibold,
  },
});

const SubscriptionDetailsCard = () => {
  const style = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const [usage, setUsage] = useState<number>(0);
  const [available, setAvailable] = useState<number>(0);
  const [expiryDate, setExpiryDate] = useState<string>();
  const [planName, setPlanName] = useState<string>("QR Mark Starter - 3 Verifications\n");

  // UseEffect hook
  useEffect(() => {
    // Fetch subscription details
    const fetchSubscriptionDetails = async () => {
      const { response } = await useSubscriptionDetails();
      if (response.status === 200) {
        const data: SubscriptionResponse = response.data;
        setUsage(data.metered_quota_usage.used_quantity);
        setAvailable(data.metered_quota_usage.available_quantity);
        // Extract plan name from the new format (e.g., "Pro Plan - srijan.kumar@scanova.io - 2450.00 USD - Annually")
        const planNameParts = data.subscription.plan.name.split(" - ");
        const basePlanName = planNameParts[0] || "QR Mark Plan";
        let planName = `QR Mark ${basePlanName.replace(" Plan", "")} - ${
          data.metered_quota_usage.available_quantity
        } Verifications`;
        setPlanName(planName);
        setExpiryDate(formatDate(data.subscription.validity));
        setIsLoading(false);
      }
    };
    fetchSubscriptionDetails();
  }, []);

  return (
    <Card>
      <Skeleton aria-label="Loading Content">
        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
          <p className={style.heading} style={{ marginBottom: "5px" }}>
            Current Subscription
          </p>
          {isLoading ? <SkeletonItem /> : <p className={style.planName}>{planName}</p>}
          {isLoading ? <SkeletonItem /> : <p className={style.subHeading}>Expires on: {expiryDate}</p>}
        </div>

        <Field
          validationMessage={
            isLoading ? (
              <SkeletonItem />
            ) : (
              <p className={style.subHeading}>
                Current Usage: {usage} / {available}
              </p>
            )
          }
          validationState="none"
        >
          <ProgressBar
            color="success"
            shape="rounded"
            thickness="large"
            value={usage}
            max={available}
            style={{ marginTop: "0.5rem" }}
          />
        </Field>
        <p
          style={{
            marginTop: "0.5rem",
            color: "#858585",
            fontSize: "0.8rem",
            fontStyle: "italic",
          }}
        >
          <a
            href="https://app.qrmark.com/subscription/plans?utm_source=microsoft&utm_medium=ms-addin&utm_campaign=dashboard"
            target="_blank"
            rel="noreferrer"
            style={{ textDecoration: "underline", color: "#858585" }}
          >
            Click here
          </a>{" "}
          to get more verifications
        </p>
        <p
          style={{
            marginTop: "0.5rem",
            color: "#858585",
            fontSize: "0.8rem",
            fontStyle: "italic",
          }}
        >
          Need help?{" "}
          <a
            style={{ textDecoration: "underline", color: "#858585" }}
            href="https://qrmark.dayschedule.com/kickoff-meeting"
            target="_blank"
            rel="noreferrer"
          >
            Book a Demo
          </a>{" "}
          or visit{" "}
          <a
            style={{ textDecoration: "underline", color: "#858585" }}
            href="http://qrmark.com/support?utm_source=microsoft&utm_medium=ms-addin&utm_campaign=dashboard"
            target="_blank"
            rel="noreferrer"
          >
            Support
          </a>
        </p>
      </Skeleton>
    </Card>
  );
};

export default SubscriptionDetailsCard;
